//Email Retrieved from: https://emailregex.com/
/**
 * Regex for Email pattern matching
 */
export const emailValidation =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/////////////////////////
////////AIRCRAFT////////
///////////////////////

/**
 * Regex for Aircraft Registration (Allows letters, numbers, dashes, 1-6 chars)
 */
export const aircraftRegistrationValidation = /^[a-zA-Z0-9-]{1,8}$/;

/**
 * Regex for Aircraft Title (Allows letters, numbers, dash, slash, 1-9 chars)
 */
export const aircraftTitleValidation = /^[a-zA-Z0-9-/]{1,9}$/;

/////////////////////////
////////USER/CREW///////
///////////////////////

/**
 *Regex to match North American and some international phone numbers
 */
// https://stackoverflow.com/questions/16699007/regular-expression-to-match-standard-10-digit-phone-number
// Entry  <132>
/* Phone number or string valid for the following formats and a few more...
    1 800 555 1234
    +1 800 555-1234
    +86 800 555 1234
    1-800-555-1234
    1 (800) 555-1234
    (800)555-1234
    (800) 555-1234
    (800)5551234
    800-555-1234
    800.555.1234
    800 555 1234x5678
    8005551234 x5678
    1    800    555-1234
    1----800----555-1234
*/
export const phoneNumberValidation = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

// Older string only validation for north american phone numbers.
// +1 (902) 555-5555
// export const phoneStringValidation = /^\+\d \(\d{3}\) \d{3}-\d{4}$/;

/**
 * Regex for general text fields (Allows text, dashes, commas, periods, apostrophes only)
 * Used for names, country, state/province,
 */
export const generalTextValidation = /^[a-zA-Z-,.'\s]*$/;

/**
 * Regex for street address fields (Allows text, numbers, apostrophe, dashes, periods, commas, paranthesis only; min length = 2)
 * New line to be trimmed, replaced with spaces
 */
export const streetAddressValidation = /^[a-zA-Z0-9'-.,()\s]{2,}$/g;

/**
 * Regex for Canadian and US zip/postal code fields (Allows text, number, dashes only; Length = 5-10 char)
 */
export const postalZipCodeValidation = /^[a-zA-Z0-9-\s]{5,10}$/;

/**
 * Regex for id fields (Allows text, number, dashes only)
 */
export const idValidation = /^[a-zA-Z0-9-]{1,10}$/;

////////////////////////
////////GENERAL////////
//////////////////////

/**
 * Regex for comment fields (Allows for letters, numbers, whitespaces, forward slash, backward slash,
 * period, comma, dollar sign, percentage, underscore, at sign, number sign, exclamation mark, question mark,
 * tild, asterick, ampersand, single quote, double quotes, parenthesis, plus, equal, dash)
 */
export const commentValidation = /^[a-zA-Z0-9\s/\\.,$%_@#!?`*&"'()+=-]+$/;

/**
 * Regex for whole numbers (up to 999,999)
 * Strip 0 at beginning
 */
export const wholeNumValidation = /^[0-9]{0,6}$/;

/**
 * Regex for decimal or floats (Allows periods, up to 999,999.99)
 * Strips 0 at beginning and decimal point (if no num after/last char = .)
 */
export const decimalNumValidation = /^(\d{0,6}(\.\d{0,2})?|\.?\d{1,2})$/;

// https://gist.github.com/yectep/4372d1166a192d5e9754
export const airportICAOValidation = /^[A-Z0-9]{4}$/;
// https://www.wikidata.org/wiki/Property:P238
export const airportIATAValidation = /^[A-Z0-9]{3}$/;

//! Do not confuse with the airport validation above.
export const airlineIATAValidation = /^[A-Z0-9]{2}$/;
